import { FC, PropsWithChildren } from "react";

export const ValidationPopupArrowIcon: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex items-center justify-center w-24 p-2 text-indigo-600 border border-indigo-600 rounded-lg h-11">
      {children}
    </div>
  );
};
